/*
|--------------------------------------------------------------------------
| Utilities: Infinite Scroll
|--------------------------------------------------------------------------
*/
/**
 * Infinite Scroll
 * @namespace
 */
__gh__webApp.utilities.infiniteScroll = {

    "init": function() {
        this.bindEvents();
    },
	
	"hasItems": function(items){
		var commonJS 	= __gh__webApp.common,
			hasItems	= (commonJS.isObjectPropertySet(items,"main") && items.main.length > 0);
			firstItem	= (hasItems) ? items.main[0] : false,
			fetchFailed = (hasItems && "success" in firstItem && !firstItem.success);
			
		if (!items || fetchFailed || !hasItems){
			return false;
		}
		return true;
	},

    "fetchJSONCallback": function(data){
        var thisObject  	= __gh__webApp.utilities.infiniteScroll,
            items       	= ("json" in data) ? data.json : {},
            start       	= data.start,
            newStart    	= data.newStart,
            count       	= data.count,
            baseURL     	= data.baseURL,
            view        	= data.view,
            dom         	= data.dom,
            startURLParam 	= data.startURLParam;

        if(!thisObject.hasItems(items)){return;}

        //Prep view data
        var loadMoreCheck   = (items.main.length == count)  ? true  : false,
            viewData        = {
                "items"             : items,
                "loadMore"          : loadMoreCheck,
                "start"             : (loadMoreCheck) ? newStart : false,
                "startURLParam"		: startURLParam,
                "view"              : view,
                "url"               : baseURL,
                "dom"               : dom,
                "count"             : count
        };

        //Append view to DOM
        __gh__webApp.utilities.fetch.handlebarsView.append({
            "data": viewData,
            "dom" : dom,
            "view": view
        });

        thisObject.triggerPostLaydownFunctions();

    },

    /**
     * Load Content
     * @param {object} options
     * @param {number} [options.start=1] - page number to start from
     * @param {number} [options.startURLParam=1] - page number to start from
     * @param {number} [options.count=10] - total number of items to get
     * @param {string} options.url - base url to fetch more content (not including start and count values, those get added by the function)
     * @param {string} options.view - view name
     * @param {string} options.dom - dom element to append to
     */
    "loadContent": function(options){
        var commonJS        = __gh__webApp.common,
            fetchJSON       = __gh__webApp.utilities.fetch.json.get,
            start           = (options.start)           ? options.start : 1,
            startURLParam   = (options.startURLParam)	? options.startURLParam : "start",
            count           = (options.count)           ? options.count : 10,
            baseURL         = (options.url)             ? options.url : null,
            view            = (options.view)            ? options.view : null,
            dom             = (options.dom)             ? options.dom : null,
            newStart        = start + 1; //if using an acutal start value vs page, try: (start + count) + 1;

        //Update url
        var updateURLOptions = {"url": baseURL, "params": {"c": count}};
			updateURLOptions.params[startURLParam] = start;
        url = commonJS.updateURLParams(updateURLOptions);

        //Load JSON
        var callbackData = {
                "start"     	: start,
                "newStart"  	: newStart,
                "count"     	: count,
                "baseURL"   	: baseURL,
                "startURLParam" : startURLParam,
                "view"      	: view,
                "dom"       	: dom
            },
            callbacks = [{
                "callback"  : "__gh__webApp.utilities.infiniteScroll.fetchJSONCallback",
                "data"      : callbackData
            }];


        //Fetch content from feed and store in data node
        fetchJSON({
            "async"         : true,
            "url"           : url,
            "callbacks"     : callbacks,
            "errorCallbacks": callbacks
        });

    },


    /**
     * Load More Content
     */
    "loadMore": function(){
        var $loadMore           = $("[data-gh-infinite-scroll-load-more=true]").first(),
            commonJS            = __gh__webApp.common,
            infiniteScrollObj   = __gh__webApp.utilities.infiniteScroll;

        //Check to see if load more data
        if ($loadMore.length){
            
            //Update load more attribute so content isn't loaded again
            $loadMore.attr("data-gh-infinite-scroll-load-more",false);

            var options     = {
                "count" 		: $loadMore.data("gh-infinite-scroll-count"),
                "start" 		: $loadMore.data("gh-infinite-scroll-start"),
                "startURLParam" : $loadMore.data("gh-infinite-scroll-start-url-param"),
                "url"   		: $loadMore.data("gh-infinite-scroll-url"),
                "view"  		: $loadMore.data("gh-infinite-scroll-view"),
                "dom"   		: $loadMore.data("gh-infinite-scroll-dom")
            };

            __gh__webApp.utilities.infiniteScroll.loadContent(options);

            console.log('infinite scroll load more...');
        }

        infiniteScrollObj.updateURLPageNumber(options);
    },


    /**
     * Load More Content
     */
    "loadMoreIfOnScreen": function(){
        var $loadMore           = $("[data-gh-infinite-scroll-load-more=true]");

        //Check to see if load more data
        if ($loadMore.length && $loadMore.isOnScreen(500)){

            __gh__webApp.utilities.infiniteScroll.loadMore();

            console.log('infinite scroll load more if on screen...');
        }

    },

    /**
     * Load more buckets to the page when the load more data attribute is on screen
     */
    "loadMoreAtPageBottom": function(){
        var buckets                 = __gh__coreData.pageData.buckets,
            thisObject              = __gh__webApp.utilities.infiniteScroll,
            $domAfterBuckets        = $("#buckets").next(),
            $footer                 = $("#footer-main");

        //Check to see if load more data
        if ($footer.isOnScreen(1000) || $domAfterBuckets.length && $domAfterBuckets.isOnScreen(1000)){
            thisObject.loadMore();
            console.log("load more at page bottom...");
        }

    },

    /**
     * As you scroll down or up the page, this checks to see if the data-gh-infinite-scroll-start value
     * is on screen and will update the url if it is
     */
    "updateURLPageNumber": function(settings){

        var commonJS            = __gh__webApp.common,
            currentPage         = __gh__webApp.currentPage,
            currentPageNumber   = commonJS.getURLParam("start");

        //Check to see if load more data
        $("[data-gh-infinite-scroll-start]").each(function(){
            var tracker                 = __gh__webApp.utilities.tracker,
                $this                   = $(this),
                thisPageNumber          = $this.data("gh-infinite-scroll-start"),
                isInfiniteScrollPage    = (currentPage.is101Things() || currentPage.isSectionBasic()) ? true : false,
                updateFirstPageURL      = (!currentPageNumber && thisPageNumber == 1 && isInfiniteScrollPage) ? false : true;

            if ($this.isOnScreen() && (thisPageNumber != currentPageNumber) && updateFirstPageURL){

                var pageData    = {
                        "start" 		: thisPageNumber,
                        "startURLParam" : $this.data("gh-infinite-scroll-start-url-param"),
                        "url"   		: $this.data("gh-infinite-scroll-url"),
                        "view"  		: $this.data("gh-infinite-scroll-view"),
                        "dom"   		: $this.data("gh-infinite-scroll-dom"),
                        "_index"		: History.getCurrentIndex()
                    },
                    pageTitle       = commonJS.getPageTitleWithPageNumber({"pageNumber":thisPageNumber,"pageNumberLabel":"Page"});
                    historyApiURL   = commonJS.updateURLParams({"params":{"start":thisPageNumber}});
                    History.replaceState(pageData, pageTitle, historyApiURL);

                    tracker.trackInfiniteScroll({"title":pageTitle});
            }

        });


    },


    "triggerPostLaydownFunctions": function(){
        //Images
        __gh__webApp.utilities.lazyImages.loadAllImages();
        smartquotes();
    },


    /**
     * Bind events
     */
    "bindEvents": function(){
		var thisObject =  __gh__webApp.utilities.infiniteScroll;
        //Load more content on scroll
        $(document).on("scroll.gh-infinite-scroll",function(){
	        thisObject.updateURLPageNumber();
	        thisObject.loadMoreIfOnScreen();
        });
        $(document).on("scroll.gh-infinite-scroll-at-bottom",this.loadMoreAtPageBottom);
        


        /**
         * History API Popstate Event Listener
         * Will only fire for a "popstate" event - https://github.com/browserstate/history.js/issues/47#issuecomment-25750285
         */
         History.Adapter.bind(window,'statechange',function(){
            var commonJS        = __gh__webApp.common,
                currentIndex    = History.getCurrentIndex(),
                internal        = (History.getState().data._index == (currentIndex - 1)),
                state           = History.getState(),
                data            = state.data;

            if (!internal && !commonJS.isObjectEmpty(data)) {
                $('html, body').animate({
                    "scrollTop": $("[data-gh-infinite-scroll-start="+data.start+"]").offset().top
                }, {
                    "start": function(){
                       $(document).off("scroll.gh-infinite-scroll");
                    },
                    "complete": function(){
                       $(document).on("scroll.gh-infinite-scroll",efficientLoadMoreFn);
                    }
                },
                "fast");
            }
        });
    }
};
